import { memo } from 'react';
import {
  Box,
  Skeleton,
  Swiper,
  Text,
  useBreakpointProp,
} from '@betty/moonlight';
import TopSlotProvider from './TopSlotProvider/TopSlotProvider';
import usePromotedContent from '../../../hooks/usePromotedContent';
import React from 'react';

function TopSlotProviders() {
  const { subproviderIds, isFetching } = usePromotedContent();

  const showArrows = useBreakpointProp({
    mobile: false,
    tablet: false,
    desktop: true,
  });

  if (isFetching) {
    return <Skeleton height={95} marginHorizontal="space-600" />;
  }

  if (!subproviderIds.length) {
    return null;
  }

  return (
    <Box paddingHorizontal="space-600">
      <Text
        locNS="games"
        variant="body-s-semi"
        locKey="topSlotProviders"
        color="darkSurfacePrimary"
        paddingBottom="space-300"
      />
      <Swiper<number>
        items={subproviderIds}
        renderOverlayItem={(provider: number) => (
          <TopSlotProvider key={provider} id={provider} position="absolute" />
        )}
        loop={false}
        dragFree={true}
        slidesToScroll={2}
        itemsGap="space-400"
        itemWidth={104}
        height={67}
        arrows={showArrows}
      />
    </Box>
  );
}

export default memo(TopSlotProviders);
